import { render, staticRenderFns } from "./Us.vue?vue&type=template&id=70bc9e6b&"
import script from "./Us.vue?vue&type=script&lang=js&"
export * from "./Us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports